/** MasterWEB Market R8.39 — lightweight viewport reveal for product cards. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('mw-card-reveal-ready');
  const observed = new WeakSet();
  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const card = entry.target;
      card.classList.add('mw-card-in-view');
      io.unobserve(card);
    }
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.08 });

  const observe = (root = document) => {
    const cards = root.matches?.('.mw-reveal-card') ? [root] : root.querySelectorAll?.('.mw-reveal-card') || [];
    let i = 0;
    for (const card of cards) {
      if (observed.has(card)) continue;
      observed.add(card);
      card.style.setProperty('--mw-reveal-delay', `${Math.min(i % 6, 5) * 45}ms`);
      io.observe(card);
      i++;
    }
  };

  observe();
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) if (node instanceof Element) observe(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
